module.exports = __webpack_public_path__ + "static/media/booking.3d48f79b.webp";